/* eslint-disable @angular-eslint/prefer-inject */
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { AbstractDataService, LoggerService } from '@pf/shared-services';
import { PackingListsService } from '@control-tower/platform-wms';
import {
    EntityChangeTrackingDto,
    IChangesSearchParams,
    IPagedResult,
    PFWmsEntities,
} from '@pf/shared-common';
import { PackingListStore } from './packing-list.store';
import {
    PackingListCreate,
    PackingListRead,
    PackingListSearchParams,
} from '../../entities/packing-list.dto';
import { Operation } from 'fast-json-patch';

@Injectable()
export class PackingListDataService extends AbstractDataService<
    PackingListRead,
    PackingListCreate
> {
    protected EntityName = PFWmsEntities.PackingList;
    constructor(
        private service: PackingListsService,
        store: PackingListStore,
        logger: LoggerService
    ) {
        super(store, logger);
    }
    protected createObs$(body: PackingListCreate): Observable<PackingListRead> {
        return this.service.packingListCreate({
            packingListViewModelCreateBody: body,
        }) as Observable<PackingListRead>;
    }
    protected deleteObs$(id: string): Observable<PackingListRead> {
        return this.service.packingListDelete({
            id,
        }) as Observable<PackingListRead>;
    }
    protected undoDeleteObs$(id: string): Observable<PackingListRead> {
        return this.service.packingListUndoDelete({
            id,
        }) as Observable<PackingListRead>;
    }
    protected getObs$(id: string): Observable<PackingListRead> {
        return this.service.packingListReadById({
            id,
        }) as Observable<PackingListRead>;
    }
    protected updateObs$(
        id: string,
        operations: Operation[]
    ): Observable<PackingListRead> {
        return this.service.packingListUpdatePatch({
            id,
            operation: operations,
        }) as Observable<PackingListRead>;
    }
    protected searchObs$(
        searchParams: PackingListSearchParams
    ): Observable<IPagedResult<PackingListRead>> {
        return this.service.packingListSearch(searchParams) as Observable<
            IPagedResult<PackingListRead>
        >;
    }

    protected searchChangesObs$(
        searchParams: IChangesSearchParams
    ): Observable<IPagedResult<EntityChangeTrackingDto<PackingListRead>>> {
        return this.service.packingListGetChanges(searchParams) as Observable<
            IPagedResult<EntityChangeTrackingDto<PackingListRead>>
        >;
    }

    claimPackingLists$(warehouseId: string, packingListIds: string[]) {
        return this.service
            .v1PackingListsClaimPost({
                packingListClaimRequest: {
                    warehouseId,
                    packingListIds,
                },
            })
            .pipe(
                map(result => {
                    const packingLists = result as PackingListRead[];
                    this.store.upsertMany(packingLists);
                    return packingLists;
                })
            );
    }

    unClaimPackingLists$(warehouseId: string, packingListIds: string[]) {
        return this.service
            .v1PackingListsUnclaimPost({
                packingListUnclaimRequest: {
                    warehouseId,
                    packingListIds,
                },
            })
            .pipe(
                map(result => {
                    const packingLists = result as PackingListRead[];
                    this.store.upsertMany(packingLists);
                    return packingLists;
                })
            );
    }
}
